import { Injectable, EventEmitter } from '@angular/core';
import { AppEvents, AppEventType } from 'app/shared/models/app-events.model';

/*
    Example of usage:

        this.eventBusService.emit(new MapWidgetToggleEvent(MapWidgetType.LayerList));
        this.eventBusService.on$(AppEventType.LineItemGridShouldPopulateChainage).subscribe(() => this.onPopulateChainageSelected());
*/
@Injectable()
export class EventBusService {
    private events: { [key: string]: EventEmitter<AppEvents> };

    constructor() {
        this.events = {};
    }

    // SUBSCRIBE TO A APP WIDE EVENT
    // List of available events are listed under the enum `AppEventType`
    on$(eventType: AppEventType): EventEmitter<AppEvents> {
        if (!this.events[eventType]) {
            this.events[eventType] = new EventEmitter<AppEvents>();
        }

        return this.events[eventType];
    }

    // BROADCAST APP WIDE EVENT
    emit(event: AppEvents) {
        if (!this.events[event.type]) {
            this.events[event.type] = new EventEmitter();
        }

        this.events[event.type].emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/event-bus.service.ts